<template>
  <h2>Sobre</h2>
  <p class="content">
    O Portal Aberto InterPsi USP é uma plataforma criada a partir do Trabalho de
    Conclusão de Curso de Renan Costa Laiz e Renan Tiago dos Santos Silva,
    alunos do curso de Bacharelado em Ciência da Computação do IME-USP, sendo
    orientados pelo professor Dr. Marco Dimas Gubitoso do IME-USP e tendo como
    cliente deste projeto o professor Dr. Wellington Zangari do IP-USP. A
    plataforma foi criada para a divulgação e gerenciamento do acervo de
    Psicologia Anomalística da USP, acervo administrado pelo professor
    Wellington que possui mais de 8 mil títulos de livros e itens em outros
    formatos de mídia, como CDs, DVDs, revistas, slides, entre outros. Na
    plataforma é possível ter acesso aos metadados dos livros do acervo, sendo
    possível a filtragem por diferentes campos como título, autores, categorias,
    entre outros, sendo também possível avaliar e comentar as obras. Para os
    administradores da plataforma, é possível o carregamento e edição das obras
    e seus metadados, a criação e edição de categorias e gerenciamento de
    usuários.
  </p>
</template>

<style scoped>
h2 {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.content {
  text-align: justify;
  margin-left: 5%;
  margin-right: 5%;
  text-indent: 30px;
}
</style>
